<script setup lang="ts">
import { useConfigStore } from "../stores/config";
import { useApplicationStore } from "../stores/application";
import { formatCurrency } from "../composables/formatCurrency";

const applicationStore = useApplicationStore();
const config = useConfigStore();

</script>
<template>
    <div class="d-flex">
        <div class="bg-white padding-app mb-2 col-12">
            <div class="col-md-3 float-start px-4">
                <img
                    :src="`${config.cdnUrl}/logos/annuities/${applicationStore.companySlug}.svg`"
                    class="product__summary--logo"
                    :alt="applicationStore.companyName"
                >
                <p class="text-center text-md-start pt-3">
                    <strong class="small">Quote number: </strong>
                </p>
                <p class="text-center text-md-start pb-3 pb-md-0 sessioncamhidetext">
                    {{ applicationStore.quoteNumber }}
                </p>
            </div>
            <div class="col-md-9 float-start">
                <div class="col-md-6 float-start pl-md-0 text-center text-md-start">
                    <h4 class="text-center text-md-start line-height-intro">
                        Your selected product
                    </h4>
                    <div class="pt-0">
                        <span><strong>Company: </strong><span data-testid="company-name">{{ applicationStore.companyName }}</span></span>
                    </div>
                    <div class="pt-2">
                        <p><strong>Product: </strong>Pension Annuity</p>
                    </div>
                    <div class="pt-2">
                        <p><strong>Annual annuity income: </strong><span>{{ formatCurrency(applicationStore.totalAnnualPension, 2) }}</span></p>
                    </div>
                </div>
                <div class="col-md-6 float-start text-center text-md-start">
                    <h4 class="text-center text-md-start line-height-intro pt-4 pt-md-0">
                        Important documents
                    </h4>
                    <div class="pt-0">
                        <a
                            target="_blank"
                            :href="`/documents/${applicationStore.quoteNumber}/${applicationStore.premiumId}/keyfacts`"
                            class="download"
                        >Quote (Key facts)</a>
                    </div>
                    <div class="pt-2">
                        <a
                            target="_blank"
                            :href="applicationStore.keyFeaturesUrl"
                            class="download"
                        >Key features</a>
                    </div>
                    <div class="pt-2">
                        <a
                            target="_blank"
                            :href="applicationStore.termsConditionsUrl"
                            class="download"
                        >Terms &amp; conditions</a>
                    </div>
                    <div class="pt-2">
                        <a
                            target="_blank"
                            :href="applicationStore.privacyUrl"
                            class="download"
                        >Privacy Notice</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

@media only screen and (max-width: 767px) {
    .float-start {
        float: none !important;
    }

    .product__summary--logo {
        margin: 0 auto;
        display: block;
    }
}
</style>
